import React, {FC} from 'react';
import {IWifiAnalyzerResults} from '../../services/AngularServices/WifiAnalyzerService';
import {getWifiAnalyzerScanRecordId, sortWifiAnalyzerResultsByDateDesc} from '../right-bar/wifi-scan-history.utils';
import {WifiScanHistoryButton} from './WifiScanHistoryButton';
import {observer} from 'mobx-react';
import './styles.scss';

interface IWifiScanHistoryButtonProps {
    onClickWifiScanHistoryButton: (wifiScanData: string) => void;
    wifiScanHistoryData?: IWifiAnalyzerResults[];
    wifiScanTranslation: string;
}

export const WifiScanHistory: FC<IWifiScanHistoryButtonProps> = observer(
    ({wifiScanHistoryData, onClickWifiScanHistoryButton, wifiScanTranslation}) => {
        const data = wifiScanHistoryData ? sortWifiAnalyzerResultsByDateDesc(wifiScanHistoryData) : [];
        return (
            <div className='scan-wifi-history-container'>
                <ul className='scan-wifi-history-list'>
                    {Array.isArray(data) &&
                        data.map((wifiScan: IWifiAnalyzerResults, index) => (
                            <li key={getWifiAnalyzerScanRecordId(wifiScan) || `wifi-scan-${index}`}>
                                <WifiScanHistoryButton
                                    wifiScanData={wifiScan}
                                    onClickWifiScanHistoryButton={onClickWifiScanHistoryButton}
                                    wifiScanTranslation={wifiScanTranslation}
                                />
                            </li>
                        ))}
                </ul>
            </div>
        );
    }
);
